module.exports = __webpack_public_path__ + "static/media/lagos.eb7a0e51.jpg";